<template>
  <v-container :id="!$vuetify.breakpoint.xsOnly ? 'bg-color' : ''" class="d-flex pa-0" fill-height fluid>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate color="#cceefc" size="72"></v-progress-circular>
    </v-overlay>

    <v-row justify="center" align="center" v-if="$vuetify.breakpoint.mdAndUp" class="bg-color">
      <v-col cols="12" sm="6" class="pa-0 ma-0" v-if="!xs_mode">
        <v-col cols="12" class="pl-6 ml-6">
          <v-img contain src="../assets/img/login.svg"> </v-img>
        </v-col> </v-col><v-col cols="12" sm="6" class="pa-0 ma-0"><v-row align="center" justify="center">
          <v-col cols="11" sm="10" md="7">
            <!-- <h2 class="mb-6 center" style="color: #00a99d">เข้าสู่ระบบ</h2> -->
            <v-img :src="require(`@/assets/icon/logo.svg`)" class="mb-12" />
            <v-text-field placeholder="Username/One ID" outlined clearable color="#00a99d" class="login_user"
              v-model="username" />
            <v-text-field placeholder="Password" outlined clearable color="#00a99d" prepend-inner-icon="mdi-key"
              required :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1" v-model="password" class="login_user" />

            <v-row>
              <v-col cols="12">
                <v-row class="ml-1">
                  <v-checkbox class="pt-0 mt-0" color="#00a99d" v-model="checkbox_consent"></v-checkbox><span
                    style="font-size: 14px">
                    ยอมรับ<a class="mt-4" style="text-decoration: none; color: #00a99d" @click="showDialog = true">
                      ข้อกำหนดการใช้บริการ </a>
                    และ
                    <a class="mt-4" style="text-decoration: none; color: #00a99d"
                      @click="showDialogPrivacy = true">นโยบายคุ้มครองข้อมูลส่วนบุคคล</a></span></v-row>
                <v-dialog v-model="showDialog" fullscreen>
                  <v-card class="pa-3" color="#CEEFED">
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-btn @click="showDialog = false" icon class="float-right">
                        <v-icon>mdi-window-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <!-- <consentDoctorAndStaff class="mt-6 mr-2" /> -->
                    <v-card-text>
                      <div class="PDFsize">
                        <pdf :src="`data:application/pdf;base64,${consent_data.dhi_tele}`" v-for="i in 10" :key="i"
                          :page="i" style="margin-top: 10px;"></pdf>
                      </div>
                    </v-card-text>
                    <v-card-actions><v-spacer></v-spacer><v-col cols="2" class="mt-3 float-right"><v-btn color="#00a99d"
                          dark outlined block @click="showDialog = false">ปิด</v-btn></v-col></v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="showDialogPrivacy" fullscreen>
                  <v-card class="pa-3" color="#CEEFED">
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-btn @click="showDialogPrivacy = false" icon class="float-right">
                        <v-icon>mdi-window-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <!-- <consentDoctorAndStaff class="mt-6 mr-2" /> -->
                    <v-card-text>
                      <div class="PDFsize">
                        <pdf :src="`data:application/pdf;base64,${consent_data.privacy}`" v-for="i in 12" :key="i"
                          :page="i" style="margin-top: 10px;"></pdf>
                      </div>
                    </v-card-text>
                    <v-card-actions><v-spacer></v-spacer><v-col cols="2" class="mt-3 float-right"><v-btn color="#00a99d"
                          dark outlined block @click="showDialogPrivacy = false">ปิด</v-btn></v-col></v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col cols="12" class="font-password">
                <!-- <router-link to="/about" style="color: #2f80ed">
                  ลืมรหัสผ่าน ?
                </router-link> -->
                <a class="font-16 w-500" href="https://one.th/type_forgot_password">ลืมรหัสผ่าน ?</a>
              </v-col>

              <v-col cols="12">
                <v-btn block :disabled="!checkbox_consent" :style="buttonStyle" @click="login()" rounded depressed
                  class="py-5">
                  <span class="font-20">เข้าสู่ระบบ</span>
                </v-btn>
              </v-col>

              <v-col cols="12">
                <v-btn rounded outlined color="#3cabab" width="100%" @click="redirect_login('mophid')">
                  <span style="font-size: 12px;">Log IN with</span>
                  <v-avatar size="70" class="ml-1">
                    <v-img src="../assets/image/AW_Logo_Provider ID_Final.png" contain></v-img>
                  </v-avatar>
                </v-btn>
              </v-col>
            </v-row>
          </v-col></v-row></v-col>
    </v-row>
    <v-row justify="center" align="center" v-else class="bg-img-color" no-gutters>
      <v-col cols="11" xs="11" sm="7" md="5" lg="4" :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'py-1'">
        <v-card :class="$vuetify.breakpoint.xsOnly ? 'elevation-0' : ''" rounded="lg" color="white"><v-card-text>
            <v-row align="center" justify="center">
              <v-col cols="11" sm="10" md="6">
                <h2 class="mb-6 center" style="color: #00a99d">เข้าสู่ระบบ</h2>
                <v-text-field label="Username/One ID" outlined clearable color="#243B55" v-model="username"
                  class="login_user" />
                <v-text-field label="Password" outlined clearable color="#243B55" prepend-inner-icon="mdi-key" required
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1" v-model="password" class="login_user" />

                <v-row>
                  <div class="font-password ml-3">
                    <v-row class="ml-1">
                      <v-checkbox class="pt-0 mt-0" color="#00a99d" v-model="checkbox_consent"></v-checkbox><span
                        style="font-size: 12px">
                        ยอมรับ<a class="mt-4" style="text-decoration: none; color: #00a99d" @click="showDialog = true">
                          ข้อกำหนดการใช้บริการ </a>
                        และ
                        <a class="mt-4" style="text-decoration: none; color: #00a99d"
                          @click="showDialogPrivacy = true">นโยบายคุ้มครองข้อมูลส่วนบุคคล</a></span></v-row>
                    <!-- <router-link to="/about" style="color: #2f80ed">
                      ลืมรหัสผ่าน ?
                    </router-link> -->
                    <a class="font-16 w-500" href="https://one.th/type_forgot_password">ลืมรหัสผ่าน ?</a>
                  </div>

                  <v-col cols="12" class="mt-3" align-center>
                    <v-btn block :disabled="!checkbox_consent" :style="buttonStyle" @click="login()"> เข้าสู่ระบบ
                    </v-btn>
                  </v-col>

                  <v-col cols="12">
                    <v-btn block outlined color="#3cabab" width="100%" @click="redirect_login('mophid')">
                      <span style="font-size: 12px;">Log IN with</span>
                      <v-avatar size="70" class="ml-1">
                        <v-img src="../assets/image/AW_Logo_Provider ID_Final.png" contain></v-img>
                      </v-avatar>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col></v-row></v-card-text></v-card></v-col>
    </v-row>

    <!-- เลือกสิทธิ์ -->
    <v-dialog v-model="dialog" fullscreen scrollable>
      <v-card tile class="bg-dialog-img-color" height="100%">
        <v-card-text :class="xs_mode ? 'pt-2' : 'pt-2 px-10'">
          <v-row justify="center" align="center" style="height: 100%" no-gutters>
            <v-col cols="11" xs="11" sm="9" md="6" :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'py-1'">
              <v-card class="elevation-1" rounded="xl">
                <v-card-title class="black--text text_header font-weight-bold" :class="xs_mode ? 'py-3 px-4' : ''">
                  <v-spacer></v-spacer>
                  <span class="py-5 font-30">เลือกสิทธิ์การใช้งาน</span>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text rounded="xl">
                  <v-row align="center" justify="center">
                    <v-col cols="12" sm="11" class="py-1"><span class="font-18 black--text w-500">เลือกสถานพยาบาล</span>
                    </v-col>
                    <v-col cols="12" sm="11" class="pb-4">
                      <v-autocomplete rounded v-model="biz_id" :items="bizList" item-text="biz_name" item-value="biz_id"
                        return-object solo dense outlined flat hide-details="auto" placeholder="เลือกสถานพยาบาล"
                        style="font-size: 14px" color="#00a99d" item-color="teal darken-2"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="11" class="py-1"><span class="font-18 black--text w-500">เลือกสิทธิ์</span>
                    </v-col>
                    <v-col cols="12" sm="11" class="py-1">
                      <v-autocomplete rounded v-model="changeRole" :items="checkbiz(roleList)" item-text="role"
                        item-value="role" return-object solo dense outlined flat hide-details="auto"
                        placeholder="เลือกสิทธิ์" style="font-size: 14px" color="#00a99d"
                        item-color="teal darken-2"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="11" class="py-6">
                      <v-row align="center" justify="center"><v-col cols="12" lg="6" md="6" sm="6"><v-btn rounded block
                            color="#00a99d" outlined @click="backward()"><span class="font-16">{{ formTitle() }}</span>
                          </v-btn></v-col><v-col cols="12" lg="6" md="6" sm="6"><v-btn rounded block depressed
                            :disabled="!changeRole" :loading="btn_loading" :style="buttonStyle_confirm"
                            @click="confirmSelectBiz()"><span
                              class="font-16">ตกลง</span></v-btn></v-col></v-row></v-col>
                  </v-row>
                  <!-- rounded
                  dark
                  depressed -->
                  <!-- color="#00a99d" -->
                </v-card-text></v-card></v-col></v-row></v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import consentDoctorAndStaff from "@/views/form/consentDoctorAndStaff.vue";
import { mapMutations, mapState } from "vuex";
import pdf from "@teckel/vue-pdf";
import consent from "../services/consent.json"
import Swal from "sweetalert2";
export default {
  components: {
    // consentDoctorAndStaff,
    pdf
  },
  data() {
    return {
      show1: false,
      username: "",
      password: "",
      overlay: false,
      btn_loading: false,
      dialog: false,
      showDialog: false,
      checkbox_consent: false,
      bizList: [],
      biz_id: null,
      role: null,
      roleList: [],
      changeRole: null,
      oneId: null,
      addSessionStorage: [],
      editedIndex: -1,
      consent_data: consent,
      showDialogPrivacy: false
    };
  },
  created() { },
  mounted() {
    if (this.login_account) {
      if (
        this.login_account.username !== "" &&
        this.login_account.password !== ""
      ) {
        this.login(this.login_account);
        this.editedIndex = 2;
      }
    }
    this.setRedirect(''); // clear ค่า loginWithRedirect เป็นค่าว่าง
  },
  computed: {
    ...mapState(["login_account"]),
    xs_mode() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    buttonStyle() {
      return {
        background: this.checkbox_consent
          ? 'linear-gradient(to right, #8dd2cd 0%, #00a99d 100%)'
          : '#eff6fc',
        color: '#ffffff',
      };
    },
    buttonStyle_confirm() {
      return {
        background: this.changeRole
          ? '#00a99d' : '#a6a6a6',
        color: '#ffffff',
      };
    },
  },
  watch: {
    showDialog(val) {
      if (val) {
        setTimeout(() => {
          document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0
        }, 100)
      }
    },
    showDialogPrivacy(val) {
      if (val) {
        setTimeout(() => {
          document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0
        }, 100)
      }
    }
  },
  methods: {
    ...mapMutations([
      "setProfile",
      "setBiz",
      "setRole",
      "setStatusReady",
      "setClinic",
      "setLogin",
      "clearStateLogin",
      "setRedirect",
    ]),
    async login(item) {
      this.overlay = true;
      await this.axios
        .post(`${process.env.VUE_APP_BACKEND_URL}/v1/login`, {
          username: item ? item.username : this.username,
          password: item ? item.password : this.password,
          type: 'login'
        })
        .then((res) => {
          const {
            data: {
              data: { account_detail: { oneId = "" } = {} } = {},
              result,
            } = {},
          } = res;
          if (result == "success") {
            let loginData = {
              username: this.username,
              password: this.password,
            };
            this.setProfile(res.data.data);
            this.setLogin(loginData);
            this.addSessionStorage = res.data.data;
            this.setClinic(this.addSessionStorage.accountDetail.clinics);
            sessionStorage.type_login = "user"
            this.bizList = Object.assign(
              [],
              res.data.data.accountDetail.clinics
            );
            this.roleList = Object.assign(
              [],
              res.data.data.accountDetail.clinics
            );
            if (item) {
              setTimeout(() => {
                this.biz_id =
                  res.data.data.accountDetail.clinics.length > 0
                    ? res.data.data.accountDetail.clinics[0]
                    : null;
                this.overlay = false;
                this.dialog = true;
              }, 200);
            } else {
              this.overlay = false;
              this.dialog = true;
            }

            this.oneId = oneId;
          }
        })
        .catch((error) => {
          this.overlay = false;
          const { response: { data: { message } = {} } = {} } = error;
          let text = "เข้าสู่ระบบไม่สำเร็จ";
          message === "do not have permission"
            ? (text = "ไม่มีสิทธิ์เข้าใช้งาน")
            : text;
          message === "The user credentials were incorrect."
            ? (text = "Username หรือ Password ไม่ถูกต้อง")
            : text;
          this.biz_ibi;

          Swal.fire({
            icon: "warning",
            html: `<span style='color: black;font-size: 24px;font-family: Sarabun, sans-serif; line-height: 5rem;'>${text}</span>`,
            showConfirmButton: false,
            timer: 2500,
          });
        });
    },
    redirect_login() {
      this.client_id = process.env.VUE_APP_BASE_CLIENTID_HEALTH
      window.location.href = `${process.env.VUE_APP_MOPH_URL}/oauth/redirect?client_id=${this.client_id}&redirect_uri=${window.location.origin}/by-pass/provider&device=web&response_type=code`;
    },
    checkbiz(data) {
      // console.log("🚀 ~ checkbiz ~ data:", data)
      let return_data = [];
      if (this.biz_id) {
        data.forEach((element) => {
          if (element.biz_id === this.biz_id.biz_id) {
            this.biz_id.role.forEach((role) => {
              if (element.role.includes(role)) {
                return_data.push(role);
              }
            });
          }
        });
      }
      return return_data;
    },
    formTitle() {
      return this.editedIndex === -1 ? "ย้อนกลับ" : "ออกเข้าสู่ระบบใหม่";
    },
    backward() {
      if (
        this.login_account &&
        this.login_account.username !== "" &&
        this.login_account.password !== ""
      ) {
        this.clearStateLogin();
        this.setRedirect('');
        this.dialog = false;
      } else {
        this.editedIndex = -1;
        this.dialog = false;
      }
    },
    async confirmSelectBiz() {
      await this.setBiz(this.biz_id);
      await this.setRole(this.changeRole);
      this.btn_loading = true;
      setTimeout(() => {
        this.overlay = false;
        this.$router.push({ name: "Dashboard" });
        if (this.changeRole == "เจ้าหน้าที่ HR") {
          this.$router.push({ name: "health-check" });
        } else if (this.changeRole == "ehp_redirect") {
          this.$router.push({ name: "HomeVisit" });
        }
        // if (this.changeRole == "แพทย์") {
        //   this.$router.push({ name: "Dashboard" });
        // } else if (this.changeRole == "พยาบาล") {
        //   this.$router.push({ name: "DashboardNurse" });
        // } else if (this.changeRole == "เภสัชกร") {
        //   this.$router.push({ name: "DashboardNurse" });
        // } else if (this.changeRole == "admin") {
        //   this.$router.push({ name: "DashboardNurse" });
        // }
      }, 500);
      setTimeout(() => {
        this.btn_loading = false;
      }, 1000);
      sessionStorage.role_name = this.changeRole;
      sessionStorage.access_token = this.addSessionStorage.access_token;
      sessionStorage.account_id = this.addSessionStorage.account_id;
      sessionStorage.oneId = this.addSessionStorage.accountDetail.one_id;
      sessionStorage.biz_id = this.biz_id.biz_id;
      sessionStorage.biz_name = this.biz_id.biz_name;
      sessionStorage.accountName =
        this.addSessionStorage.accountDetail.account_title_th +
        this.addSessionStorage.accountDetail.first_name_th +
        " " +
        this.addSessionStorage.accountDetail.last_name_th;
      const data = {
        one_id: sessionStorage.oneId,
        biz_id: sessionStorage.biz_id,
        role: sessionStorage.role_name,
        status: true,
      };
      this.axios
        .put(`${process.env.VUE_APP_BACKEND_URL}/v1/staffs/status`, data)
        .then((res) => {
          if (res.data) {
            this.setStatusReady(true);
          }
        });
      // this.setStatusReady(true);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Sarabun&display=swap");

::v-deep .login_user.v-text-field input {
  line-height: 70px;
}

.bg-color {
  height: 100%;
  background-image: url("../assets/img/bg.png");
}

.bg-img-color {
  height: 100%;
  background-image: url("../assets/img/bg.png");
  background-repeat: no-repeat;
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: bottom;
  background-size: 370%;
}

.bg-dialog-img-color {
  height: 100%;
  background-image: url("../assets/img/bg.png");
  background-size: 370%;
}

.PDFsize {
  /* padding-top: 2%; */
  padding-bottom: 1%;
  padding-left: 15%;
  padding-right: 15%;
}

::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.8rem !important;
}
</style>
